import React, {useState} from 'react'
import fetcher from "lib/utils/fetcher";
import Breadcrumbs from '@/components/common/Breadcrumbs'
import mainStyles from "@/public/styles/common/content.module.scss";
import contentStyles from "@/public/styles/pages/blog/category/content.module.scss";
import {connect, useDispatch} from 'react-redux'
import SeoData from '@/components/core/SeoData'
import {buildPagination} from "@/lib/utils/pagination";
import styles from "@/public/styles/pages/blog/category/content.module.scss";
import gridStyles from "@/public/styles/components/grid/grid-list.module.scss";
import PreviewDefault from "@/components/common/list/PreviewDefault";
import Link from "next/link";
import SubMenu from '@/components/exercises/SubMenu'
import {wrapper} from "@/store/store";
import cx from "classnames";

const API_HOST = process.env.NEXT_PUBLIC_API_URL;

async function fetchItems(page, pageSize) {
    const fetchPostsUrl = `${API_HOST}/api/training/exercises?page=${page}&page_size=${pageSize}`
    return await fetcher(fetchPostsUrl);
}

export const getServerSideProps = wrapper.getServerSideProps((store) => async (ctx) => {
    ctx.res.setHeader(
        "Cache-Control",
        "max-age=300, stale-while-revalidate=60, stale-if-error=86400"
    );

    if (!ctx.query) {
        return {
            notFound: true,
        }
    }

    let page: any = 1
    if (ctx.query?.page != null) {
        page = ctx.query.page
    }
    let pageSize = 30;

    const fetchCategoriesUrl = `${API_HOST}/api/training/exercise-categories/list`
    const categories = await fetcher(fetchCategoriesUrl);

    const exercises = await fetchItems(page, pageSize);

    if (!exercises.items.length) {
        return {
            notFound: true,
        }
    }

    return {
        props: {
            categories: categories,
            items: exercises.items,
            totalCount: exercises.total_count,
            page: parseInt(page),
            pageSize: pageSize
        }
    };
})

function Category(props) {
    const {items, categories, totalCount, pageSize, page, isMobile} = props

    let breadcrumbs = [];

    const [exercises, setExercises] = useState(items)
    const [loadedPage, setLoadedPage] = useState(page)
    const [currentPage, setCurrentPage] = useState(page)

    if (page != loadedPage) {
        setLoadedPage(page)
        setCurrentPage(page)
        setExercises(items)
    }

    const totalPages = Math.ceil(totalCount / pageSize)

    let pagesToShow = buildPagination(currentPage, totalPages)

    breadcrumbs.push({
        path: '',
        title: 'Упражнения',
        disabled: true
    })


    return (
        <>
            <SeoData title={'Упражнения на группы мышц'} description={'Список упражнения для тренировок в тренажерном зале и дома на различные группы мышц'} keywords={``}/>
            {
                !isMobile &&
                <Breadcrumbs
                    items={breadcrumbs}
                />
            }

            <div className={cx(mainStyles.contentContainer, {[contentStyles.noCrumbs]: isMobile})}>
                <div className={contentStyles.headerWrap}>
                    <h1>Упражнения</h1>
                </div>

                <SubMenu category={null} categories={categories}/>

                <div className={styles.newPostsContainer}>
                    <div className={gridStyles.gridList}>
                        {exercises?.map((post) => {
                            let item = {
                                '_id': post._id,
                                'name': post.name,
                                'category': {
                                    'name': post.category.name,
                                    'link': `/exercises/${post.category.urlKey}`,
                                    'dotColor': post.category.dotColor,
                                },
                                'previewImage': post.previewImage?.fileUrl || null,
                                'contentShort': post.descriptionShort || '',
                                'link': `/exercise/${post.urlKey}`,
                            };

                            return (<PreviewDefault key={post._id} item={item}/>);
                        })}
                    </div>
                    <div className={styles.paginationContainer}>
                        {
                            (currentPage < totalPages) &&
                            <div className={styles.loadMore} onClick={async () => {
                                const newList = await fetchItems(currentPage + 1, pageSize)
                                let newItems = newList.items
                                setExercises([...exercises, ...newItems]);
                                setCurrentPage(parseInt(newList.current_page));
                            }}><span>Загрузить еще</span></div>
                        }

                        {totalPages > 1 &&
                        <div className={styles.pagination}>
                            {
                                (currentPage != 1) &&
                                <Link href={`/exercises?page=${currentPage - 1}`}>
                                    <a onClick={() => {
                                        setLoadedPage(null)
                                    }}>Назад</a>
                                </Link>
                            }
                            {
                                <Link href={`/exercises?page=1`}>
                                    <a className={(currentPage == 1) ? styles.currentPage : styles.defaultPage}
                                       onClick={() => {
                                           setLoadedPage(null)
                                       }}
                                    >1</a>
                                </Link>
                            }
                            {
                                (1 == currentPage && 1 != totalPages) &&
                                <div className={styles.pageLine}></div>
                            }
                            {
                                pagesToShow.map(page => {
                                    return (
                                        <span key={page}>
                                    <Link key={page} href={`/exercises?page=${page}`}>
                                        <a className={(currentPage == page) ? styles.currentPage : styles.defaultPage}
                                        onClick={() => {
                                        setLoadedPage(null)
                                    }}>{page}</a>
                                    </Link>
                                            {
                                                (page == currentPage && page != totalPages) &&
                                                <div className={styles.pageLine}></div>
                                            }
                                </span>
                                    )
                                })
                            }
                            {
                                (currentPage != totalPages) &&
                                <Link href={`/exercises?page=${totalPages}`}>
                                    <a className={(currentPage == totalPages) ? styles.currentPage : styles.defaultPage}
                                       onClick={() => {
                                           setLoadedPage(null)
                                       }}>{totalPages}</a>
                                </Link>

                            }
                            {
                                (currentPage != totalPages) &&
                                <Link href={`/exercises?page=${currentPage + 1}`}>
                                    <a onClick={() => {
                                        setLoadedPage(null)
                                    }}>Вперед</a>
                                </Link>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>
            {
                isMobile &&
                <Breadcrumbs
                    items={breadcrumbs}
                />
            }
        </>
    )
}

function mapStateToProps(state) {
    return {
        isMobile: state.core.is_mobile
    }
}

export default connect(mapStateToProps)(Category)